<template>
  <div class="page-content">
    <Header></Header>
    <div class="questionnaire-container content">
      <PageTitle title="Let's get you started with Symbium"></PageTitle>

      <div class="padding-x padding-y fg-2 margin-auto">
        <div class="max-1200">
          <div class="big-body">General Information</div>
          <div class="gap-3x"></div>
          <div class="line-break-gray"></div>
          <div class="gap-2x"></div>
          <SelectQuestion
            question="What type of organization are you a part of?"
            :answer="organizationTypeAnswersGroup.currentAnswer"
            :answerOptions="organizationTypeAnswersGroup.answers"
            :questionId="organizationTypeAnswersGroup.id"
            :onAnswerChange="onAnswerChange"
            :error="errors.organizationType"
          ></SelectQuestion>
          <div class="gap-2x"></div>
          <div class="line-break-gray"></div>
          <div v-if="organizationTypeAnswersGroup.currentAnswer">
            <div class="gap-2x"></div>
            <div v-if="isBusiness" class="flex-box vertically-at-top wrap">
              <div class="calc-left big-width">
                <div class="question-text">
                  What is the name of your business or organization?
                </div>
              </div>
              <div class="calc-right">
                <InputWithError
                  :model="organizationName.value"
                  :name="'organizationName'"
                  :onchange="(event) => onAnswerChange('organizationName', event.target.value)"
                  :placeholder="'Business/organization name'"
                  :error="errors.organizationName"
                />
              </div>
            </div>
            <div v-if="isGovernment">
              <div class="flex-box vertically-at-top wrap">
                <div class="calc-left big-width">
                  <div class="question-text">
                    What jurisdiction do you represent?
                  </div>
                </div>
                <div class="calc-right">
                  <InputWithError
                    :model="organizationCity.value"
                    :name="'organizationCity'"
                    :onchange="(event) => onAnswerChange('organizationCity', event.target.value)"
                    :placeholder="'City or jurisdiction'"
                    :error="errors.organizationCity"
                  />
                </div>
              </div>
              <div class="gap-2x"></div>
              <div class="line-break-gray"></div>
              <div class="gap-2x"></div>
              <SelectQuestion
                :question="organizationSizeQuestionText"
                :answer="organizationSizeAnswersGroup.currentAnswer"
                :answerOptions="organizationSizeAnswersGroup.answers"
                :questionId="organizationSizeAnswersGroup.id"
                :onAnswerChange="onAnswerChange"
                :error="errors.organizationSize"
              ></SelectQuestion>
            </div>
            <div class="gap-2x"></div>
            <div class="line-break-gray"></div>
          </div>
        </div>
      </div>
      <div class="mobile-gap-6x"></div>
      <CartContainer :availableItems="availableItems" :error="errors.cart" />
      <div class="mobile-gap-6x"></div>
      <div class="desktop-gap-10x" v-if="!showQuestion || isBusiness"></div>

      <div class="padding-x padding-y fg-2 margin-auto" v-if="isGovernment && showQuestion">
        <div class="max-1200">
          <div class="big-body">Data</div>
          <div class="gap-3x"></div>
          <div class="line-break-gray"></div>
          <div v-if="showDataQuestion">
            <div class="gap-2x"></div>
            <SelectQuestion
              question="What is the primary source of the ADU regulations being applied in your jurisdiction?"
              :answer="aduPrimarySourceAnswersGroup.currentAnswer"
              :answerOptions="aduPrimarySourceAnswersGroup.answers"
              :questionId="aduPrimarySourceAnswersGroup.id"
              :onAnswerChange="onAnswerChange"
              :additionalTextFieldValue="aduPrimarySourceExplain"
              :additionalTextFieldIndexes="[1, 2]"
              :onTextChange="(text) => this.answerChanged('aduPrimarySourceExplain', text)"
              :textPlaceholders="aduPrimarySourcePlaceholders"
              :error="errors.aduPrimarySource"
            ></SelectQuestion>
            <div class="gap-2x"></div>
            <div class="line-break-gray"></div>
          </div>
          <div class="gap-2x"></div>
          <div class="flex-box vertically-at-top wrap">
            <div class="calc-left">
              <div class="question-text">
                Where can we find your zoning code?
              </div>
            </div>
            <div class="calc-right">
              <input
                type="text"
                class="text-input"
                placeholder="Provide a link if available"
                v-model="this.zoningCode.value"
                @change="(event) => onAnswerChange('zoningCode', event.target.value)"
              />
            </div>
          </div>
          <div class="gap-2x"></div>
          <div class="line-break-gray"></div>
          <div class="gap-2x"></div>
          <div class="bold">Our services require high-quality data to give high-quality results.  Please let us know if you have the following in a digitized format.</div>
          <div>Suggested data formats: Shapefile, GeoJSON, link to GIS service.</div>
          <div class="gap-3x"></div>
          <div class="line-break-gray"></div>
          <div class="gap-3x"></div>
          <div class="flex-box data-questions wrap">
            <div v-for="digitalQuestionGroup in dataQuestionsGroup" :key="digitalQuestionGroup.id" class="question-group">
              <SelectQuestion
                :question="digitalQuestionGroup.id"
                :answer="digitalQuestionGroup.currentAnswer"
                :answerOptions="digitalQuestionGroup.answers"
                :questionId="digitalQuestionGroup.id"
                :onAnswerChange="onAnswerChange"
                :noFlexBox="true"
                :error="errors[digitalQuestionGroup.id]"
              ></SelectQuestion>
              <div v-if="digitalQuestionGroup.currentAnswer == '0'">
                <div class="gap-1x"></div>
                <input
                  type="text"
                  class="text-input"
                  placeholder="Provide a link if available"
                  v-model="digitalQuestionGroup.link.value"
                  @change="(event) => dataLinkChange(digitalQuestionGroup.link, event.target.value)"
                />
              </div>
            </div>
          </div>
          <div class="gap-3x"></div>
          <div class="line-break-gray"></div>
        </div>
      </div>
      <SummaryContainer :href="href"></SummaryContainer>
    </div>
  </div>
</template>

<script>
import SelectQuestion from "src/components/questionnaires/SelectQuestion.vue";
import PageTitle from 'src/components/layouts/PageTitle.vue'
import Header from 'src/components/layouts/Header.vue'
import SummaryContainer from "src/components/layouts/SummaryContainer.vue";
import CartContainer from "src/components/common/CartContainer.vue";
import _ from "lodash";
import EventBus from './EventBus.js'
import InputWithError from 'src/components/common/InputWithError.vue'

export default {
  name: 'QuestionnaireContainer',
  components: { InputWithError, PageTitle, SelectQuestion, SummaryContainer, CartContainer, Header },
  data: function() {
    var organizationAllAvailableAnswers = this.$questionnaire.getAllAvailableAnswers();
    var dataObject = {};
    var numberOfAccounts = this.$questionnaire.getAnswer('numberOfAccounts');
    if (!numberOfAccounts.value) {
      numberOfAccounts = this.$questionnaire.setAnswer('numberOfAccounts', 1);
    }
    _.each(_.keys(organizationAllAvailableAnswers["organizationYesNoData"]), (key) => {
      dataObject[key] = this.$questionnaire.getAnswer(key);
      dataObject[key + '_link'] = this.$questionnaire.getAnswer(key + '_link');
    })
    return Object.assign(dataObject, {
      organizationAllAvailableAnswers: organizationAllAvailableAnswers,
      organizationType: this.$questionnaire.getAnswer('organizationType'),
      organizationCity: this.$questionnaire.getAnswer('organizationCity'),
      organizationSize: this.$questionnaire.getAnswer('organizationSize'),
      aduPrimarySource: this.$questionnaire.getAnswer('aduPrimarySource'),
      organizationName: this.$questionnaire.getAnswer('organizationName'),
      aduPrimarySourceExplain: this.$questionnaire.getAnswer('aduPrimarySourceExplain'),
      aduPrimarySourcePlaceholders: organizationAllAvailableAnswers['aduPrimarySourcePlaceholders'],
      userName: '',
      userEmail: '',
      startTime: undefined,
      endTime: undefined,
      zoningCode: this.$questionnaire.getAnswer('zoningCode'),
      showDataQuestion: this.$cart.hasDataProduct(),
      showQuestion: !this.$cart.isEmpty(),
      numberOfAccounts,
      availableItems: this.$cart.availableItems(this.$questionnaire),
      errors: {},
    });
  },
  computed: {
    organizationTypeAnswersGroup: function() {
      return this.generateOrganizationAnswersGroup(this.organizationType);
    },
    organizationSizeAnswersGroup: function() {
      return this.generateOrganizationAnswersGroup(this.organizationSize);
    },
    organizationCityAnswersGroup: function() {
      return this.generateOrganizationAnswersGroup(this.organizationCity);
    },
    aduPrimarySourceAnswersGroup: function() {
      return this.generateOrganizationAnswersGroup(this.aduPrimarySource);
    },
    dataQuestionsGroup: function() {
      var questions = this.organizationAllAvailableAnswers["organizationYesNoData"];
      if(this.showDataQuestion) {
        return _.map(questions, this.getYesNoQuestionAnswer);
      } else {
        return _.map(_.omit(questions, ['Building area & footprints']), this.getYesNoQuestionAnswer);
      }
    },
    organizationSizeQuestionText: function() {
      return 'How many people live in your jurisdiction?';
    },
    isGovernment() {
      return this.organizationType.value == '0';
    },
    isBusiness() {
      return this.organizationType.value == '1';
    },
    href() {
      return '/shop/checkout'
    },
  },
  methods: {
    onAnswerChange: function(groupId, answer) {
      this[groupId] = this.$questionnaire.setAnswer(groupId, answer);
      if(groupId == 'organizationType') {
        this.$cart.clearCart();
        this.$questionnaire.clearContacts();
        this.showQuestion = false;
        this.availableItems = this.$cart.availableItems(this.$questionnaire);
        this.errors = {}
        this.notice
      }
      EventBus.$emit(EventBus.onAnswerChangedEvent);
      this.errors[groupId] = null;
    },
    normalizeAnswers: function(text, answers) {
      return { text: text, enum: answers.indexOf(text).toString() };
    },
    generateOrganizationAnswersGroup: function(questionnaire, nestedKey) {
      var id = questionnaire.id;
      var availableAnswers = this.organizationAllAvailableAnswers[id];
      if (nestedKey) availableAnswers = availableAnswers[nestedKey];
      return {
        id: id,
        currentAnswer: questionnaire.value,
        answers: _.map(availableAnswers, (answer) => this.normalizeAnswers(answer, availableAnswers)),
      };
    },
    getYesNoQuestionAnswer: function(answers, question) {
      var currentAnswer = this.$data[question];
      return {
        id: question,
        currentAnswer: currentAnswer.value,
        answers: _.map(answers, (answer) => this.normalizeAnswers(answer, answers)),
        link: this.$data[question + '_link']
      };
    },
    setOrganizationCity: function(city) {
      this.$questionnaire.setAnswer('organizationCity', city);
      EventBus.$emit(EventBus.onAnswerChangedEvent);
    },
    onDateSelect: function(dateClickInfo) {
      this.startTime = dateClickInfo.start;
      this.endTime = dateClickInfo.end;
    },
    createGoogleCalendarEvent: function() {
      if (this.startTime != undefined && this.userEmail.length > 0) {
        this.$createGoogleCalendarEvent(this.startTime, this.endTime, this.userEmail);
      } else {
        alert('You need to enter email and pick an available slot!');
      }
    },
    clearQuestionnaireData: function() {
      this.$questionnaire.clearData();
      Object.assign(this.$data, this.$options.data.apply(this))
    },
    dataLinkChange: function(yesNoQuestionLink, value) {
      this.$questionnaire.setAnswer(yesNoQuestionLink.id, value);
    },
    onCartChanged() {
      this.showDataQuestion = this.$cart.hasDataProduct();
      this.showQuestion = !this.$cart.isEmpty();
      this.errors.cart = null;
    },
    showErrors(errors) {
      this.errors = {};
      _.each(errors, (value, key) => {
        this.errors[key] = value;
      })
      if(_.keys(this.errors).length > 0) {
        this.$nextTick(function () {
          var errorMessages = document.getElementsByClassName('error-message');
          if(errorMessages.length > 0) {
            errorMessages[0].scrollIntoView();
            window.scrollBy(0, -100);
          }
        });
      }
    }
  },
  watch: {
    organizationCity() {
      EventBus.$emit('city-changed')
    },
    organizationType() {
      EventBus.$emit('organization-type-changed')
    }
  },
  created() {
    EventBus.$on(EventBus.onCartChangedEvent, this.onCartChanged)
    EventBus.$on('cart-error', this.showErrors)
  },
  beforeDestroy() {
    EventBus.$off(EventBus.onCartChangedEvent, this.onCartChanged)
    EventBus.$off('cart-error', this.showErrors)
  },
}
</script>
<style lang="scss">
  .questionnaire-container {
    padding-bottom: 120px;
  }

  .data-questions {
    .question-group {
      width: fit-content;
      margin-right: 32px;
    }

    .question-group:nth-child(4) {
      margin-right: 0;
    }

    select, input {
      margin-top: 8px !important;
    }

    .calc-right {
      text-align: left;
    }

    .question-group.question {
      width: 100%;
    }
  }

  @media screen and (max-width: 1200px) {
    .data-questions .question-group {
      margin-bottom: 32px;
    }
  }

  @media screen and (max-width: 864px) {
    .data-questions .question-group {
      margin-bottom: 24px;
    }

    select, input {
      margin-top: 0px !important;
    }

    input, select {
      width: 100% !important
    }

    .question {
      margin-bottom: 0;
    }
  }
</style>
